import dynamic from 'next/dynamic';
const Teaser = dynamic(() => import('@/components/teaser/Teaser'));
const Accordion = dynamic(() => import('@/components/accordion/Accordion'));
import StaticImage from '@/components/image/StaticImage';
import RichText from '@/components/RichText/RichText';
const Tabs = dynamic(() => import('@/components/tabs/Tabs'));
import SimpleHeaderText from '@/components/SimpleHeaderText';
const FixedColumnLayout = dynamic(() => import('@/components/fixedColumnLayout/FixedColumnLayout'));
const LeftNavi = dynamic(() => import('@/components/leftNavi/LeftNavi'));
import FeatureList from '@/components/featureList/FeatureList';
const LinkList = dynamic(() => import('@/components/linkList/LinkList'));
const Link = dynamic(() => import('@/components/linkList/Link'));
const AlertBox = dynamic(() => import('@/components/alertBox/AlertBox'));
import ContentModule from '@/components/contentModule/ContentModule';
import ContentRow from '@/components/contentModule/ContentRow';
const HeroHomeClient = dynamic(() => import('@/components/hero/HeroHomeClient'));
const Highlights = dynamic(() => import('@/components/introduction/Highlights'));
const HighlightBanner = dynamic(() => import('@/components/highlightBanner/HighlightBanner'));
const ImageGallery = dynamic(() => import('@/components/imageGallery/ImageGallery'));
const Breadcrumb = dynamic(() => import('@/components/breadcrumb/Breadcrumb'));
const LinkBanner = dynamic(() => import('@/components/linkBanner/LinkBanner'));
const AccordionElementArea = dynamic(() => import('@/components/accordion/AccordionElementArea'));
const IFrame = dynamic(() => import('@/components/iFrame/IFrame'));
import IntroWrapperClient from '@/components/intro/IntroWrapperClient';
const FooterClient = dynamic(() => import('@/Layouts/Footer/FooterClient'));
const StaticPageClient = dynamic(() => import('@/templates/StaticPageClient'));
const Header = dynamic(() => import('@/Layouts/Header/Header'));

export const componentMappingsNotFoundConfig = {
  componentMappings: {
    'website:pages/static': StaticPageClient,

    'website:components/richText': RichText,
    'website:components/image': StaticImage,
    'website:components/footer': FooterClient,
    'website:components/header': Header,
    'website:components/highlights': Highlights,
    'website:components/highlightBanner': HighlightBanner,
    'website:components/accordion': Accordion,
    'website:components/accordionElement': AccordionElementArea,
    'website:components/tabs': Tabs,
    'website:components/simpleHeaderText': SimpleHeaderText,
    'website:components/fixedColumnLayout': FixedColumnLayout,
    'website:components/leftNavi': LeftNavi,
    'website:components/featureList': FeatureList,
    'website:components/teaser': Teaser,
    'website:components/link': Link,
    'website:components/linkList': LinkList,
    'website:components/alertBox': AlertBox,
    'website:components/contentModule': ContentModule,
    'website:components/contentRow': ContentRow,
    'website:components/imageGallery': ImageGallery,
    'website:components/hero': HeroHomeClient,
    'website:components/breadcrumb': Breadcrumb,
    'website:components/linkBanner': LinkBanner,
    'website:components/introduction': IntroWrapperClient,
    'website:components/iFrame': IFrame
  }
};
